import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  makeStyles,
  Button,
  Paper,
  Grid,
} from "@material-ui/core";
import Page from "src/components/Page";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import { Alert } from "@material-ui/lab";
import { kmMessages, getSystemLabel } from "src/constant/Messages";
import { apiEndpoints, apiGetRequest, apiPostRequest } from "src/utils/api/api";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  massagebox: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  firstlevtintend: {
    textIndent: "-1.19em",
    textDecoration: "none",
  },
  seclevtintend: {
    textIndent: "-1.19em",
    marginLeft: theme.spacing(3),
  },
  secondol: {
    paddingLeft: theme.spacing(2),
    " & li::marker": {
      content: "attr(point-attr)",
    },
    " & li": {
      paddingLeft: "0.3em",
    },
  },
  thirdol: {
    paddingLeft: theme.spacing(4),
    " & li::marker": {
      content: "attr(point-attr)",
    },
    " & li": {
      paddingLeft: "0.3em",
    },
  },

  img: {
    margin: "auto",
    display: "block",
    [theme.breakpoints.up("lg")]: {
      maxWidth: "42%",
    },
    [theme.breakpoints.down("lg")]: {
      maxWidth: "52%",
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: "70%",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "95%",
    },
    maxHeight: "100%",
  },
}));

const PolicyView = ({
  globalData,
  setAuthorized,
  setCurrentUserData,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  setLogoutUser,
}) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const acceptPolicy = () => {
    enableGlobalLoader();

    apiPostRequest(apiEndpoints.setConsent.path, { action: "policy" }, true)
      .then((data) => {
        disableGlobalLoader();
        apiGetRequest(apiEndpoints.getLoggedUser.path, true)
          .then((data) => {
            disableGlobalLoader();
            setAuthorized(true);
            setCurrentUserData(data);
            navigate("/");
          })
          .catch((error) => {
            disableGlobalLoader();
            if (error.response) {
              if (error.response.status === 403) {
                if (error.response.data) {
                  if (
                    error.response.data.code === "MEMBER_TASKS_NOT_ACCEPTED"
                  ) {
                    navigate("/deklaracjazadaniacz");
                    return;
                  } else if (
                    error.response.data.code === "OBSERVER_TASKS_NOT_ACCEPTED"
                  ) {
                    navigate("/deklaracjazadaniaobs");
                    return;
                  }
                }
              }
            }
            displaySnackbar({
              isOpen: true,
              severity: "error",
              autoHideDuration: 10000,
              message: kmMessages.error.global.apierror,
            });
            setLogoutUser();
          });
      })
      .catch((error) => {
        disableGlobalLoader();
        displaySnackbar({
          isOpen: true,
          severity: "error",
          autoHideDuration: 10000,
          message: kmMessages.error.global.apierror,
        });
        setLogoutUser();
      });
  };

  const noAcceptPolicy = () => {
    setLogoutUser();
  };

  return (
    <Page
      className={classes.root}
      title="Polityka Bezpieczeństwa Przetwarzania Danych Osobowych w Urzędzie Marszałkowskim Województwa Podlaskiego w Białymstoku"
    >
      <Container maxWidth="lg">
        <Box
          display="flex"
          flexWrap="wrap"
          alignContent="center"
          p={1}
          css={{ height: "4vh" }}
        ></Box>
        <Box
          display="flex"
          flexDirection="column"
          height="100%"
          justifyContent="center"
        >
          <Box mb={1}>
            {getSystemLabel('programPolicyAccept', globalData.systemInfo) ? (
              <Alert severity="warning" className={classes.massagebox}>
                <div>{getSystemLabel('programPolicyAccept', globalData.systemInfo)}</div>
              </Alert>
            ) : (
              <></>
            )}
            <Paper>
              <Box p={2} pl={5}>
                <Typography
                  color="textPrimary"
                  component="h1"
                  align="center"
                  variant="h2"
                  paragraph
                >
                  Polityka Bezpieczeństwa Przetwarzania Danych Osobowych w
                  Urzędzie Marszałkowskim Województwa Podlaskiego w Białymstoku{" "}
                </Typography>
                {/* <Typography component="p" display="block" paragraph> */}
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Rozdział I Postanowienia ogólne i definicje
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 1
                </Typography>
                <ol>
                  <Typography component="li">
                    Polityki Bezpieczeństwa Przetwarzania Danych Osobowych w
                    Urzędzie Marszałkowskim Województwa Podlaskiego w
                    Białymstoku powstała w celu zapewnienia odpowiedniego
                    poziomu bezpieczeństwa przetwarzania danych osobowych i
                    stanowi zbiór zasad oraz procedur obowiązujących
                    przy przetwarzaniu danych osobowych.
                  </Typography>
                  <Typography component="li">
                    Podstawą do opracowania i wdrożenia Polityki Bezpieczeństwa
                    Przetwarzania Danych Osobowych są:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      ustawy z dnia 10 maja 2018 r. o ochronie danych osobowych,
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      Rozporządzenie Parlamentu Europejskiego i Rady (UE)
                      2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób
                      fizycznych w związku z przetwarzaniem danych osobowych i w
                      sprawie swobodnego przepływu takich danych oraz uchylenia
                      dyrektywy 95/46/WE.
                    </Typography>
                  </ol>{" "}
                  <Typography component="li">
                    Przetwarzanie danych osobowych w Urzędzie Marszałkowskim
                    Województwa Podlaskiego w Białymstoku jest dopuszczalne
                    wyłącznie pod warunkiem przestrzegania przepisów prawa
                    wymienionych w ust. 2, w tym niniejszej Polityki
                    Bezpieczeństwa Przetwarzania Danych Osobowych i Polityki
                    Zarządzania Systemami Informatycznymi.
                  </Typography>
                  <Typography component="li">
                    Polityka Bezpieczeństwa Przetwarzania Danych Osobowych ma
                    zastosowanie do ochrony danych osobowych przetwarzanych w
                    Urzędzie Marszałkowskim Województwa Podlaskiego, w celu ich
                    bezpiecznego wykorzystania i odnosi się zarówno do
                    zabezpieczenia danych przetwarzanych tradycyjnie
                    (papierowo), jak i danych przetwarzanych w systemach
                    teleinformatycznych.
                  </Typography>
                  <Typography component="li">
                    Do stosowania zasad wymienionych w Polityce Bezpieczeństwa
                    Przetwarzania Danych Osobowych oraz Polityce Zarządzania
                    Systemami Informatycznymi zobligowani są wszyscy pracownicy
                    Urzędu Marszałkowskiego Województwa Podlaskiego
                    przetwarzający dane osobowe.
                  </Typography>
                </ol>
                <Typography paragraph></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 2
                </Typography>
                <Typography component="p" display="block" paragraph>
                  Definicje
                </Typography>
                <ol>
                  <Typography component="li">
                    Określenia i skróty użyte w Polityce Bezpieczeństwa
                    Przetwarzania Danych Osobowych oznaczają:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      ustawa – ustawę z dnia 10 maja 2018 r. o ochronie danych
                      osobowych;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      RODO – rozporządzenie Parlamentu Europejskiego i Rady (UE)
                      2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób
                      fizycznych w związku z przetwarzaniem danych osobowych i w
                      sprawie swobodnego przepływu takich danych oraz uchylenia
                      dyrektywy 95/46/WE;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      Administrator – oznacza osobę fizyczną lub prawną, organ
                      publiczny, jednostkę lub inny podmiot, który samodzielnie
                      lub wspólnie z innymi ustala cele i sposoby przetwarzania
                      danych osobowych;
                    </Typography>
                    <Typography point-attr="4)" component="li">
                      Urząd/UMWP – Urząd Marszałkowski Województwa Podlaskiego
                      w Białymstoku;
                    </Typography>
                    <Typography point-attr="5)" component="li">
                      IOD – Inspektor Ochrony Danych;
                    </Typography>
                    <Typography point-attr="6)" component="li">
                      ZIOD – Zastępca Inspektora Ochrony Danych;
                    </Typography>
                    <Typography point-attr="7)" component="li">
                      Współuczestniczący w procesie – komórka organizacyjna
                      urzędu, która w ramach zadań określonych w Regulaminie
                      organizacyjnym przetwarza dane osobowe niezbędne do
                      realizacji wskazanego celu. W ramach współuczestnictwa w
                      procesie za realizację obowiązków dotyczących ochrony
                      danych osobowych, określonych w niniejszym dokumencie,
                      odpowiedzialni są Dyrektorzy Departamentów/Biur lub inne
                      osoby, kierujące pracą komórki organizacyjnej Urzędu,
                      wskazane w Regulaminie organizacyjnym;
                    </Typography>
                    <Typography point-attr="8)" component="li">
                      Właściciel zbioru danych osobowych – osobę (Dyrektor
                      Departamentu, Biura, Osoby na samodzielnych stanowiskach
                      itp.), która kieruje pracą danej komórki organizacyjnej i
                      odpowiada za nadzór nad eksploatacją, rozwojem,
                      utrzymaniem, korzystaniem, bezpieczeństwem i dostępem do
                      zbioru danych osobowych;
                    </Typography>
                    <Typography point-attr="9)" component="li">
                      dane osobowe – wszelkie informacje o zidentyfikowanej lub
                      możliwej do zidentyfikowania osobie fizycznej („osobie,
                      której dane dotyczą”); możliwa do zidentyfikowania osoba
                      fizyczna to osoba, którą można bezpośrednio lub pośrednio
                      zidentyfikować, w szczególności na podstawie
                      identyfikatora takiego jak imię i nazwisko, numer
                      identyfikacyjny, dane o lokalizacji, identyfikator
                      internetowy lub jeden bądź kilka szczególnych czynników
                      określających fizyczną, fizjologiczną, genetyczną,
                      psychiczną, ekonomiczną, kulturową lub społeczną tożsamość
                      osoby fizycznej;
                    </Typography>
                    <Typography point-attr="10)" component="li">
                      przetwarzanie – operacje lub zestaw operacji wykonywanych
                      na danych osobowych lub zestawach danych osobowych w
                      sposób zautomatyzowany lub niezautomatyzowany, takie jak
                      zbieranie, utrwalanie, organizowanie, porządkowanie,
                      przechowywanie, adaptowanie lub modyfikowanie, pobieranie,
                      przeglądanie, wykorzystywanie, ujawnianie poprzez
                      przesłanie, rozpowszechnianie lub innego rodzaju
                      udostępnianie, dopasowywanie lub łączenie, ograniczanie,
                      usuwanie lub niszczenie;
                    </Typography>
                    <Typography point-attr="11)" component="li">
                      zbiór danych – uporządkowany zestaw danych osobowych
                      dostępnych według określonych kryteriów, niezależnie od
                      tego, czy zestaw ten jest scentralizowany,
                      zdecentralizowany czy rozproszony funkcjonalnie lub
                      geograficznie;
                    </Typography>
                    <Typography point-attr="12)" component="li">
                      podmiot przetwarzający – oznacza osobę fizyczną lub
                      prawną, organ publiczny, jednostkę lub inny podmiot, który
                      przetwarza dane osobowe w imieniu administratora;
                    </Typography>
                    <Typography point-attr="13)" component="li">
                      naruszenie ochrony danych osobowych – oznacza naruszenie
                      bezpieczeństwa prowadzące do przypadkowego lub niezgodnego
                      z prawem zniszczenia, utracenia, zmodyfikowania,
                      nieuprawnionego ujawnienia lub nieuprawnionego dostępu
                      do danych osobowych przesyłanych, przechowywanych lub w
                      inny sposób przetwarzanych;
                    </Typography>
                    <Typography point-attr="14)" component="li">
                      Inspektor Bezpieczeństwa Teleinformatycznego „IBTI”–
                      zgodnie z Polityką Zarządzania Systemami Informatycznymi w
                      UMWP w Białymstoku;
                    </Typography>
                    <Typography point-attr="15)" component="li">
                      Administrator Systemów Informatycznych „ASI” – zgodnie z
                      Polityką Zarządzania Systemami Informatycznymi w UMWP w
                      Białymstoku,
                    </Typography>
                    <Typography point-attr="16)" component="li">
                      osoba upoważniona lub użytkownik systemu – osobę
                      posiadającą upoważnienie wydane przez ADO lub uprawnioną
                      przez niego osobę i dopuszczoną jako użytkownik do
                      przetwarzania danych osobowych, zwaną dalej
                      „użytkownikiem”;
                    </Typography>
                    <Typography point-attr="17)" component="li">
                      osoby zatrudnione przy przetwarzaniu danych osobowych –
                      wszystkie osoby, w tym użytkownicy systemu
                      informatycznego, mające dostęp do danych osobowych;
                    </Typography>
                    <Typography point-attr="18)" component="li">
                      PUODO – Prezes Urzędu Ochrony Danych Osobowych;
                    </Typography>
                  </ol>
                </ol>
                <Typography paragraph></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Rozdział II Zarządzanie przetwarzaniem danych osobowych
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Obszary przetwarzania danych osobowych
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 3
                </Typography>
                <ol>
                  <Typography component="li">
                    Obszar przetwarzania danych osobowych w Urzędzie obejmuje
                    budynki, pomieszczenia i części pomieszczeń, w których
                    przetwarzane są dane osobowe oraz miejsca, gdzie znajdują
                    się serwery bazodanowe i zarządzające systemem
                    informatycznym Urzędu.
                  </Typography>
                  <Typography component="li">
                    Obszar przetwarzania danych osobowych określony jest w
                    „Wykazie budynków, pomieszczeń lub części pomieszczeń Urzędu
                    Marszałkowskiego Województwa Podlaskiego, tworzących obszar,
                    w którym przetwarzane są dane osobowe”, stanowiącym
                    załącznik nr 1 do Polityki Bezpieczeństwa Przetwarzania
                    Danych Osobowych.
                  </Typography>
                </ol>
                <Typography paragraph></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Gromadzenie danych osobowych
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                ></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 4
                </Typography>
                <Typography component="p" display="block" paragraph>
                  Dane osobowe przetwarzane w Urzędzie mogą być uzyskiwane
                  bezpośrednio od osób, których te dane dotyczą lub pośrednio,
                  w granicach dozwolonych przepisami prawa.
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 5
                </Typography>
                <ol>
                  <Typography component="li">
                    Zebrane dane osobowe mogą być wykorzystane wyłącznie do
                    celów, dla jakich były, są lub będą zbierane i przetwarzane.
                  </Typography>
                  <Typography component="li">
                    Współuczestniczący w procesie ma obowiązek znać podstawy
                    prawne, na jakich komórka przez niego kierowana dokonuje
                    konkretnych czynności przetwarzania danych osobowych. Jeżeli
                    podstawą jest uzasadniony interes Administratora,
                    Współuczestniczący w procesie ma obowiązek znać konkretny
                    realizowany przetwarzaniem interes Administratora.
                  </Typography>
                  <Typography component="li">
                    W przypadku konieczności udostępnienia dokumentów i danych,
                    wśród których znajdują się dane osobowe niemające
                    bezpośredniego związku z celem udostępnienia, należy
                    bezwzględnie dokonać anonimizacji tych danych osobowych.
                  </Typography>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 6
                </Typography>
                <Typography component="p" display="block" paragraph>
                  W przypadku konieczności pozyskania zgody na przetwarzanie
                  danych od osoby, której one dotyczą, każdy Współuczestniczący
                  w procesie jest odpowiedzialny za jej pozyskanie
                  i przechowywanie.
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Realizacja praw osób, których dane dotyczą
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Obowiązek informacyjny
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 7
                </Typography>
                <ol>
                  <Typography component="li">
                    Za dopełnienie obowiązku, o którym mowa w art. 13 ust. 1 i 2
                    oraz art. 14 ust. 1 i 2 RODO odpowiedzialni są
                    Współuczestniczący w procesie, w stosunku do konkretnych
                    czynności przetwarzania, które nadzorują oraz osoby, które
                    na polecenie Administratora dokonują czynności przetwarzania
                    w stosunku do procesów, do których zostały upoważnione.
                  </Typography>
                  <Typography component="li">
                    Obowiązku informacyjnego należy dopełnić w jeden z
                    wymienionych sposobów:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      poprzez ustne przekazanie informacji, o której mowa w art.
                      13 ust. 1 i 2 oraz art. 14 ust. 1 i 2 RODO oraz odebraniu
                      od osoby, której dane dotyczą oświadczenia o dopełnieniu
                      tego obowiązku;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      zamieszczenia stosownej klauzuli na formularzu stosowanym
                      do zbierania informacji;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      poprzez zamieszczenie informacji na stronie internetowej
                      Urzędu np. w miejscu gdzie opisywany jest sposób
                      załatwiania danej sprawy.
                    </Typography>
                  </ol>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                ></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Żądania osób
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 8
                </Typography>
                <ol>
                  <Typography component="li">
                    W przypadku, gdy osoba której dane dotyczą korzysta z praw
                    określonych w art. 15-22 RODO, za przekazanie informacji,
                    której wniosek dotyczy, odpowiedzialni są poszczególni
                    Dyrektorzy/Osoby na samodzielnych stanowiskach/Kierujący
                    komórkami. Zbiorczej odpowiedzi udziela Inspektor Ochrony
                    Danych.
                  </Typography>
                  <Typography component="li">
                    Realizując prawo dostępu przysługujące osobie, której dane
                    dotyczą należy zapewnić gwarancje ochrony praw i wolności
                    osób trzecich. W szczególności w przypadku powzięcia
                    wiarygodnej wiadomości o tym, że wykonanie żądania osoby o
                    wydanie kopii danych lub prawa do przeniesienia danych może
                    niekorzystnie wpłynąć na prawa i wolności innych osób (np.
                    prawa związane z ochroną danych innych osób, prawa własności
                    intelektualnej, tajemnicę handlową, dobra osobiste itp.), W
                    takiej sytuacji możliwe jest zwrócenie się do osoby w celu
                    wyjaśnienia wątpliwości lub podjąć inne prawem dozwolone
                    kroki, łącznie z odmową zadośćuczynienia żądaniu.
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      W przypadku, gdy w żadnym procesie nie są przetwarzane
                      dane osoby wnioskującej, informuje się osobę o tym, że w
                      UMWP nie są przetwarzane dane jej dotyczących.
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      W przypadku odmowy należy poinformować osobę, w ciągu
                      miesiąca od otrzymania żądania, o odmowie rozpatrzenia
                      żądania i o prawach osoby z tym związanych.
                    </Typography>
                  </ol>
                  <Typography component="li">
                    Na żądanie osoby dotyczące dostępu do jej danych, należy
                    poinformować osobę, czy przetwarzane są jej dane oraz o
                    szczegółach przetwarzania, zgodnie z art. 15 RODO, a także
                    należy udzielić osobie dostępu do danych jej dotyczących.
                    Dostęp do danych może być zrealizowany przez wydanie kopii
                    danych.
                  </Typography>
                  <Typography component="li">
                    Na żądanie wydaje się osobie kopię danych jej dotyczących, a
                    fakt wydania kopii danych odnotowuje IOD w prowadzonym
                    rejestrze.
                  </Typography>
                  <Typography component="li">
                    W przypadku, gdy osoba w rozsądny sposób wykaże
                    nieprawidłowości danych należy dokonać sprostowania
                    nieprawidłowych danych na żądanie osoby.
                  </Typography>
                  <Typography component="li">
                    W przypadku żądania osoby uzupełnienia i aktualizacji
                    dotyczących jej danych Administrator ma prawo odmówić
                    uzupełnienia danych, jeżeli uzupełnienie byłoby niezgodne z
                    celami przetwarzania danych.
                  </Typography>
                  <Typography component="li">
                    Żądanie osoby usunięcie dotyczących jej danych może być
                    zrealizowane, gdy:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      dane nie są niezbędne do celów, w których zostały zebrane
                      ani przetwarzane w innych celach;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      zgoda na ich przetwarzanie została cofnięta, a nie ma
                      innej podstawy prawnej przetwarzania;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      osoba wniosła skuteczny sprzeciw względem przetwarzania
                      tych danych;
                    </Typography>
                    <Typography point-attr="4)" component="li">
                      dane były przetwarzane niezgodnie z prawem;
                    </Typography>
                    <Typography point-attr="5)" component="li">
                      konieczność usunięcia wynika z obowiązku prawnego;
                    </Typography>
                    <Typography point-attr="6)" component="li">
                      żądanie dotyczy danych dziecka zebranych na podstawie
                      zgody w celu świadczenia usług społeczeństwa
                      informacyjnego oferowanych bezpośrednio dziecku (np.
                      udział w konkursie na stronie internetowej).
                    </Typography>
                  </ol>
                  <Typography component="li">
                    Przy realizacji prawa do usunięcia danych każdorazowo należy
                    przeprowadzić weryfikację, czy nie zachodzą wyjątki, o
                    których mowa w art. 17. ust. 3 RODO.
                  </Typography>
                  <Typography component="li">
                    Jeżeli dane podlegające usunięciu zostały upublicznione np.
                    w Internecie należy podjąć rozsądne działania, w tym środki
                    techniczne, by poinformować innych administratorów
                    przetwarzających te dane osobowe, o potrzebie usunięcia
                    danych i dostępu do nich.
                  </Typography>
                  <Typography component="li">
                    Ograniczenia przetwarzania danych na żądanie osoby można
                    dokonać, gdy:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      osoba kwestionuje prawidłowość danych – na okres
                      pozwalający sprawdzić ich prawidłowość;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      przetwarzanie jest niezgodne z prawem, a osoba, której
                      dane dotyczą, sprzeciwia się usunięciu danych osobowych,
                      żądając w zamian ograniczenia ich wykorzystywania;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      UMWP nie potrzebuje już danych osobowych, ale są one
                      potrzebne osobie, której dane dotyczą, do ustalenia,
                      dochodzenia lub obrony roszczeń;
                    </Typography>
                    <Typography point-attr="4)" component="li">
                      osoba wniosła sprzeciw względem przetwarzania z przyczyn
                      związanych z jej szczególną sytuacją – do czasu
                      stwierdzenia, czy po stronie UMW zachodzą prawnie
                      uzasadnione podstawy nadrzędne wobec podstaw sprzeciwu.
                    </Typography>
                  </ol>
                  <Typography component="li">
                    W trakcie ograniczenia przetwarzania dozwolone jest jedynie
                    przechowywanie danych. Natomiast nie wolno na tej grupie
                    danych wykonywać innych czynności bez zgody osoby, której
                    dane dotyczą, chyba że w celu ustalenia, dochodzenia lub
                    obrony roszczeń, lub w celu ochrony praw innej osoby
                    fizycznej lub prawnej, lub z uwagi na ważne względy interesu
                    publicznego. Należy poinformować osobę o ewentualnym
                    uchyleniu ograniczenia przetwarzania.
                  </Typography>
                  <Typography component="li">
                    Na żądanie osoby wydaje się w ustrukturyzowanym, powszechnie
                    używanym formacie nadającym się do odczytu maszynowego lub
                    przekazuje innemu podmiotowi, jeśli jest to możliwe, dane
                    dotyczące tej osoby, które dostarczyła ona Administratorowi,
                    przetwarzane na podstawie zgody tej osoby lub w celu
                    zawarcia lub wykonania umowy z nią zawartej, w systemach
                    informatycznych UMWP.
                  </Typography>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                ></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Rejestr czynności przetwarzania danych
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 9
                </Typography>
                <ol>
                  <Typography component="li">
                    Za inwentaryzację procesów/czynności przetwarzania w UMWP
                    odpowiedzialni są kierujący komórkami organizacyjnymi UMWP
                    lub osoby na samodzielnych stanowiskach w swoim zakresie
                    merytorycznym.
                  </Typography>
                  <Typography component="li">
                    Rejestr czynności przetwarzania danych prowadzi IOD. Zakres
                    informacji zawartych w rejestrze to:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      Nazwa czynności przetwarzania/procesu;
                    </Typography>
                    <Typography point-attr="1)" component="li">
                      Administrator;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      Współuczestniczący w procesie;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      Cel/Cele przetwarzania;
                    </Typography>
                    <Typography point-attr="4)" component="li">
                      Kategorie osób;
                    </Typography>
                    <Typography point-attr="5)" component="li">
                      Kategorie danych (art. 6 ust. 1 RODO) i podstawa prawna
                      przetwarzania (art. 6 ust. 1 RODO);
                    </Typography>
                    <Typography point-attr="6)" component="li">
                      Szczególne kategorie danych (art. 9 ust. 1 RODO) i
                      podstawa prawna przetwarzania (art. 9 ust. 2 RODO);
                    </Typography>
                    <Typography point-attr="7)" component="li">
                      Przetwarzania danych osobowych dotyczących wyroków
                      skazujących oraz naruszeń prawa lub powiązanych środków
                      bezpieczeństwa i podstawa prawna przetwarzania (art. 6
                      ust. 1 RODO);
                    </Typography>
                    <Typography point-attr="8)" component="li">
                      Przepis szczególny legalizujący przetwarzanie danych
                      zwykłych, szczególnych kategorii danych oraz danych
                      osobowych dotyczących wyroków skazujących oraz naruszeń
                      prawa lub powiązanych środków bezpieczeństwa;
                    </Typography>
                    <Typography point-attr="9)" component="li">
                      Źródło danych;
                    </Typography>
                    <Typography point-attr="10)" component="li">
                      Nazwa systemu lub oprogramowania;
                    </Typography>
                    <Typography point-attr="11)" component="li">
                      Kategorie odbiorców (innych niż podmioty przetwarzające);
                    </Typography>
                    <Typography point-attr="12)" component="li">
                      Przekazanie danych osobowych do państwa trzeciego lub
                      organizacji międzynarodowej;
                    </Typography>
                    <Typography point-attr="13)" component="li">
                      Planowane terminy usunięcia kategorii danych;
                    </Typography>
                    <Typography point-attr="14)" component="li">
                      Nazwa współadministratora i dane kontaktowe;
                    </Typography>
                    <Typography point-attr="15)" component="li">
                      Ogólny opis technicznych i organizacyjnych środków
                      bezpieczeństwa zgodnie z art. 32 ust. 1;
                    </Typography>
                    <Typography point-attr="16)" component="li">
                      Informacja o DPIA.
                    </Typography>
                  </ol>
                  <Typography component="li">
                    3. Za zgłoszenie potrzeby aktualizacji procesu
                    odpowiedzialni są kierujący komórkami organizacyjnymi UMWP
                    lub osoby na samodzielnych stanowiskach.
                  </Typography>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                ></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Rejestr kategorii czynności przetwarzania danych
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 10
                </Typography>
                <ol>
                  <Typography component="li">
                    Rejestr kategorii czynności przetwarzania danych prowadzi
                    IOD.
                  </Typography>
                  <Typography component="li">
                    Za zgłoszenie i aktualizację zawartych w Rejestrze kategorii
                    czynności przetwarzania danych osobowych odpowiedzialni są
                    kierujący komórkami organizacyjnymi UMWP lub osoby na
                    samodzielnych stanowiskach w swoim zakresie merytorycznym.
                  </Typography>
                  <Typography component="li">
                    Zakres informacji zawartych w rejestrze kategorii czynności
                    przetwarzania danych to:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      Kategorie przetwarzań;
                    </Typography>
                    <Typography point-attr="1)" component="li">
                      Ogólny opis technicznych i organizacyjnych środków
                      bezpieczeństwa;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      Nazwa i dane kontaktowe administratora;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      Nazwa i dane kontaktowe współadministratora;
                    </Typography>
                    <Typography point-attr="4)" component="li">
                      Nazwa i dane kontaktowe przedstawiciela administratora;
                    </Typography>
                    <Typography point-attr="5)" component="li">
                      Inspektor ochrony danych administratora;
                    </Typography>
                    <Typography point-attr="6)" component="li">
                      System informatyczny;
                    </Typography>
                    <Typography point-attr="7)" component="li">
                      Czas trwania przetwarzania;
                    </Typography>
                    <Typography point-attr="8)" component="li">
                      Nazwy państw trzecich lub organizacji międzynarodowych, do
                      których dane są przekazywane;
                    </Typography>
                    <Typography point-attr="9)" component="li">
                      Dokumentacja odpowiednich zabezpieczeń danych osobowych
                      przekazywanych na podstawie art. 49 ust. 1 akapit drugi;
                    </Typography>
                    <Typography point-attr="10)" component="li">
                      Nazwa i dane kontaktowe podprzetwarzającego
                      (podwykonawcy);
                    </Typography>
                    <Typography point-attr="11)" component="li">
                      Kategorie podpowierzonych przetwarzań.
                    </Typography>
                  </ol>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                ></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Wykaz zbiorów danych osobowych
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 11
                </Typography>
                <ol>
                  <Typography component="li">
                    IOD prowadzi wykaz zbiorów danych przetwarzanych w Urzędzie
                    Marszałkowskim Województwa Podlaskiego w Białymstoku,
                    którego wzór stanowi załącznik nr 2 do Polityki
                    Bezpieczeństwa Przetwarzania Danych Osobowych.
                  </Typography>
                  <Typography component="li">
                    Do wykazu wpisuje się wszystkie przetwarzane w UMWP zbiory
                    danych osobowych.
                  </Typography>
                  <Typography component="li">
                    Szczegółowe informacje dotyczące stosowanego sprzętu oraz
                    oprogramowania danego systemu informatycznego są zawarte w
                    Polityce zarządzania systemem informatycznym.
                  </Typography>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                ></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Nadawanie upoważnień
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 12
                </Typography>
                <ol>
                  <Typography component="li">
                    Do przetwarzania danych osobowych mogą być dopuszczone
                    wyłącznie osoby posiadające upoważnienie nadane przez ADO
                    lub przez upoważnioną przez niego osobę.
                  </Typography>
                  <Typography component="li">
                    W przypadku stażystów lub praktykantów upoważnienie do
                    przetwarzania danych osobowych nadawane jest wyłącznie w
                    zakresie wglądu.
                  </Typography>
                  <Typography component="li">
                    Wzór upoważnienia do przetwarzania danych osobowych określa
                    załącznik nr 4 do Polityki Bezpieczeństwa Przetwarzania
                    Danych Osobowych.
                  </Typography>
                  <Typography component="li">
                    Przy nadawaniu upoważnień zastosowanie ma następująca
                    procedura:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      Właściciele zbiorów danych osobowych lub Kierownik komórki
                      organizacyjnej, w której pracuje lub ma pracować osoba
                      upoważniona, występują z pisemnym wnioskiem o nadanie
                      upoważnienia. Z wnioskiem o nadanie upoważnienia
                      do przetwarzania danych osobowych, w przypadku Kierowników
                      komórek organizacyjnych występują: Marszałek Województwa,
                      Wicemarszałek Województwa, członek Zarządu Województwa lub
                      Sekretarz Województwa;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      Wzór wniosku stanowi załącznik nr 3 do Polityki
                      Bezpieczeństwa Przetwarzania Danych Osobowych;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      Wszystkie pola wniosku, we współpracy z właściwą komórką
                      organizacyjną ds. kadr, muszą zostać uzupełnione, za
                      wyjątkiem identyfikatora. Do IOD dostarczany jest w pełni
                      wypełniony wniosek.
                    </Typography>
                    <Typography point-attr="4)" component="li">
                      W przypadku upoważniania osób, które będą przetwarzać dane
                      na podstawie umowy cywilnoprawnej z wnioskiem o nadanie
                      upoważnienia występuje oraz potwierdza okres upoważnienia
                      Kierownik komórki organizacyjnej, który zawarł umowę
                      cywilnoprawną. Okres upoważnienia nie może być dłuższy
                      niż okres, na który zawarto umowę cywilnoprawną i nie może
                      przekroczyć 1 roku;
                    </Typography>
                    <ol className={classes.thirdol}>
                      <Typography point-attr="a)" component="li">
                        dopuszcza się nadanie upoważnienia na innej podstawie
                        np. zarządzenia Marszałka. Przepisy pkt. 4 stosuje się
                        odpowiednio.
                      </Typography>
                    </ol>
                    <Typography point-attr="5)" component="li">
                      W przypadku stażystów lub praktykantów okres upoważnienia
                      potwierdza Kierownik komórki organizacyjnej, która
                      zapewnia organizację stażu lub praktyki.
                    </Typography>
                    <Typography point-attr="6)" component="li">
                      We wniosku należy wskazać jakie zbiory danych osobowych
                      przetwarzał będzie pracownik, stosując nazewnictwo zbiorów
                      zgodnie z Wykazem zbiorów danych osobowych, o którym mowa
                      w § 11;
                    </Typography>
                    <ol className={classes.thirdol}>
                      <Typography point-attr="a)" component="li">
                        dopuszcza się upoważnienie do wszystkich zbiorów danych
                        osobowych określonych w aktualnym wykazie zbiorów danych
                        osobowych ze wskazaniem zakresu lub celu przetwarzania;
                      </Typography>
                      <Typography point-attr="b)" component="li">
                        każdy wniosek podpisywany jest przez Kierownika komórki
                        organizacyjnej i przedstawiany do akceptacji przez
                        Sekretarza Województwa i Marszałka Województwa;
                      </Typography>
                      <Typography point-attr="c)" component="li">
                        grupa osób, którym dopuszczalne jest nadanie
                        upoważnienia do wszystkich zbiorów to osoby, których
                        zakres obowiązków i charakter pracy wymaga przetwarzania
                        danych we wszystkich zbiorach m.in.: pracownicy
                        kancelarii/ sekretariatów, informatycy, radcowie prawni;
                      </Typography>
                    </ol>
                    <Typography point-attr="7)" component="li">
                      Wszelkie niezbędne informacje potrzebne do prawidłowego
                      uzupełnienia wniosku znajdują się w Wykazie zbiorów danych
                      osobowych:
                    </Typography>
                    <ol className={classes.thirdol}>
                      <Typography point-attr="a)" component="li">
                        w przypadku, gdy w kolumnie „właściciel zbioru” wpisany
                        jest Urząd Marszałkowski Województwa Podlaskiego oznacza
                        to, że właścicielem tego zbioru jest każdy kierownik
                        komórki organizacyjnej w swoim zakresie merytorycznym;
                      </Typography>
                      <Typography point-attr="b)" component="li">
                        w przypadku, gdy w kolumnie „program” znajduje się
                        więcej niż jeden program należy do wniosku wpisać tylko
                        te programy, w których osoba upoważniona będzie
                        przetwarzać dane osobowe.
                      </Typography>
                    </ol>
                    <Typography point-attr="8)" component="li">
                      W przypadku upoważniania osoby do przetwarzania danych w
                      zbiorze, którego właścicielem jest kierownik innej komórki
                      organizacyjnej niż ta, w której pracuje lub ma pracować
                      osoba upoważniana, pod wnioskiem podpisuje się również
                      właściciel tego zbioru;
                    </Typography>
                    <Typography point-attr="9)" component="li">
                      Wniosek dostarczany jest do IOD, który:
                    </Typography>
                    <ol className={classes.thirdol}>
                      <Typography point-attr="a)" component="li">
                        przygotowuje upoważnienie;
                      </Typography>
                      <Typography point-attr="b)" component="li">
                        b) jeżeli stwierdza jakiekolwiek braki we wniosku –
                        całość zwraca do osoby wnioskującej o nadanie uprawnień
                        wskazanej w punkcie 1, celem uzupełnienia braków
                        formalnych.
                      </Typography>
                    </ol>
                    <Typography point-attr="10)" component="li">
                      Wniosek, o którym mowa w pkt. 1 należy dostarczyć do IOD
                      najpóźniej w pierwszym dniu pracy osoby, która ma zostać
                      upoważniona lub w pierwszym dniu, w którym planowane jest
                      rozpoczęcia przez osobę upoważnianą przetwarzania danych.
                      Przed rozpoczęciem przetwarzania danych musi być nadane
                      upoważnienie;
                    </Typography>
                    <Typography point-attr="11)" component="li">
                      W przypadku osób nowozatrudnionych Kierownik komórki
                      organizacyjnej, w której ma pracować ta osoba dostarcza do
                      komórki organizacyjnej ds. kadr prawidłowo i w pełni
                      wypełniony wniosek o nadanie upoważnienia do przetwarzania
                      danych osobowych wraz z pozostałymi wnioskami, o których
                      mowa w Polityce Zarządzania Systemami Informatycznymi
                      jeżeli dotyczy, najpóźniej dzień przed rozpoczęciem pracy
                      przez osobę, która ma zostać upoważniona. Osoba
                      nowozatrudniona odbiera komplet w/w dokumentów w komórce
                      organizacyjnej ds. kadr wraz z kartą obiegową.
                    </Typography>
                    <Typography point-attr="12)" component="li">
                      Dopuszczenie osoby, przez Właściciela zbioru lub
                      Kierownika komórki organizacyjnej, do przetwarzania danych
                      bez stosownego upoważnienia do przetwarzania danych
                      osobowych stanowi poważne naruszenie zasad określonych w
                      niniejszej Polityce, Ustawie i RODO;
                    </Typography>
                    <Typography point-attr="13)" component="li">
                      W przypadku aktualizacji zakresu upoważnienia wystawiane
                      jest nowe upoważnienie z kolejnym wolnym numerem z
                      ewidencji upoważnień. Wcześniejsze upoważnienie uważa się
                      za anulowane. We wniosku muszą zostać wskazane wszystkie
                      zbiory, do których upoważniona ma zostać osoba
                      przetwarzająca. Przepisy pkt. 1–8 stosuje się odpowiednio.
                    </Typography>
                    <Typography point-attr="14)" component="li">
                      W przypadku konieczności rozszerzenia zakresu upoważnienia
                      na krótki okres czasu, do 10 dni roboczych, związany z
                      wykonaniem dodatkowych czynności (np. audyt, kontrola
                      itp.) dopuszcza się nadanie nowego upoważnienia bez
                      anulowania poprzedniego. Upoważnienie takie wystawiane
                      jest na czas określony, bez wskazywania stanowiska i
                      komórki organizacyjnej, w której pracuje osoba upoważniana
                      i dot. wykonania konkretnego zadania. Uprawnionym
                      do wnioskowania i potwierdzenia okresu, na który ma być
                      wystawione upoważnienie jest Sekretarz Województwa.
                    </Typography>
                  </ol>
                  <Typography component="li">
                    Upoważnienie wystawiane jest w dwóch egzemplarzach. Jeden
                    egzemplarz zbiera i przechowuje IOD, natomiast drugi
                    otrzymuje upoważniany pracownik.
                  </Typography>
                  <Typography component="li">
                    IOD prowadzi ewidencję osób upoważnionych do przetwarzania
                    danych osobowych. Wzór ewidencji stanowi załącznik nr 5 do
                    Polityki Bezpieczeństwa Przetwarzania Danych Osobowych.
                  </Typography>
                  <Typography component="li">
                    Wszelkiego rodzaju zmiany dot. przeniesienia pracownika,
                    zmiany zakresu obowiązków lub zmiany w strukturze
                    organizacyjnej Urzędu wymagają weryfikacji upoważnień.
                    Właściciele zbiorów danych osobowych lub kierownicy komórek
                    organizacyjnych zobligowani są do przekazania IOD wniosku o
                    nadanie upoważnienia zgodnie z załącznikiem nr 3 do Polityki
                    Bezpieczeństwa Przetwarzania Danych Osobowych najpóźniej w
                    dniu, od którego zaczynają obowiązywać zmiany.
                  </Typography>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 13
                </Typography>
                <ol>
                  <Typography component="li">
                    Każda osoba, w zależności od rodzaju zatrudnienia i formy
                    współpracy, dopuszczona przez ADO do przetwarzania danych
                    osobowych podpisuje:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      oświadczenie o zachowaniu w tajemnicy danych osobowych
                      oraz sposobów ich zabezpieczeń, którego wzór stanowi
                      załącznik nr 6 do Polityki Bezpieczeństwa Przetwarzania
                      Danych Osobowych;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      porozumienie zawierane pomiędzy Marszałkiem Województwa
                      Podlaskiego, a pracownikiem zatrudnionym przy
                      przetwarzaniu danych osobowych, w sprawie wykorzystania
                      oddanego do dyspozycji sprzętu informatycznego,
                      oprogramowania oraz zasobów sieci informatycznej, którego
                      wzór stanowi załącznik nr 7 do Polityki Bezpieczeństwa
                      Przetwarzania Danych Osobowych – w przypadku
                      wykorzystywania sprzętu i wewnętrznej infrastruktury
                      teleinformatycznej UMWP.
                    </Typography>
                  </ol>
                  <Typography component="li">
                    IOD zobowiązany jest do zbierania, ewidencjonowania
                    i przechowywania:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      oświadczeń osób przetwarzających dane osobowe o zachowaniu
                      w tajemnicy danych osobowych oraz sposobów ich
                      zabezpieczeń;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      porozumień zawartych z osobami zatrudnionymi przy
                      przetwarzaniu danych osobowych w zakresie wykorzystania
                      oddanego im do dyspozycji sprzętu informatycznego,
                      oprogramowania oraz zasobów sieci informatycznej.
                    </Typography>
                  </ol>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                ></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Cofanie upoważnień
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 14
                </Typography>
                <ol>
                  <Typography component="li">
                    Za poinformowanie IOD o konieczności cofnięcia upoważnienia
                    do przetwarzania danych osobowych odpowiedzialni są
                    Kierownicy komórek organizacyjnych, którzy wnioskowali o
                    nadanie upoważnienia dla tej osoby poprzez przesłanie
                    stosownej informacji na adres e-mail:
                    pracownicyinfo@podlaskie.eu. Przypadki każdorazowego
                    cofnięcia upoważnienia to m. in.: zmiana komórki
                    organizacyjnej, ustanie stosunku pracy osoby upoważnionej
                    lub zmiana zakresu obowiązków związana ze zmianą dostępu do
                    zbiorów danych osobowych.
                  </Typography>
                  <Typography component="li">
                    W przypadku cofnięcia upoważnienia do przetwarzania danych
                    osobowych osoby przetwarzającej dane na podstawie umowy
                    cywilnoprawnej, osoba wnioskująca o nadanie upoważnienia, o
                    której mowa w § 12 ust. 4 pkt. 4 niezwłocznie informuje,
                    o tym fakcie IOD celem cofnięcia upoważnienia.
                  </Typography>
                  <Typography component="li">
                    IOD odnotowuje w prowadzonej ewidencji osób upoważnionych do
                    przetwarzania danych osobowych datę cofnięcia upoważnienia.
                  </Typography>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                ></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Udostępnianie danych osobowych
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 15
                </Typography>
                <ol>
                  <Typography component="li">
                    ADO udostępnia dane osobowe przetwarzane we własnych
                    zbiorach tylko osobom lub podmiotom uprawnionym do ich
                    otrzymania na mocy przepisów prawa.
                  </Typography>
                  <Typography component="li">
                    Dane osobowe mogą być udostępniane w następujących
                    przypadkach:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      na podstawie wniosku od podmiotu uprawnionego do
                      otrzymywania danych osobowych na podstawie przepisów;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      na podstawie umowy z innym podmiotem, w ramach której
                      istnieje konieczność udostępnienia danych;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      na podstawie wniosku osoby, której dane dotyczą.
                    </Typography>
                  </ol>
                  <Typography component="li">
                    Wniosek o udostępnienie danych osobowych powinien zawierać
                    informacje umożliwiające wyszukanie żądanych danych
                    osobowych w zbiorze oraz wskazywać ich zakres i
                    przeznaczenie.
                  </Typography>
                  <Typography component="li">
                    Udostępniając dane osobowe należy zaznaczyć, że można je
                    wykorzystać wyłącznie zgodnie z celem, dla którego zostały
                    udostępnione.
                  </Typography>
                  <Typography component="li">
                    W przypadku żądania udzielenia informacji na temat
                    przetwarzanych danych osobowych na pisemny wniosek
                    pochodzący od osoby, której dane dotyczą, odpowiedź na
                    wniosek następuje w terminie 30 dni od daty jego otrzymania.
                  </Typography>
                  <Typography component="li">
                    Wniosek o udostępnienie przekazywany jest do właściciela
                    zbioru danych osobowych, który wstępnie weryfikuje
                    poprawność wniosku oraz podstawę prawną udostępnienia
                    i informuje o tym IOD.
                  </Typography>
                  <Typography component="li">
                    IOD opiniuje wniosek o udostępnienie i przekazuje informację
                    właścicielowi zbioru danych osobowych.
                  </Typography>
                  <Typography component="li">
                    Właściciel zbioru danych osobowych jest odpowiedzialny za
                    przygotowanie danych osobowych do udostępnienia w zakresie
                    wskazanym we wniosku oraz powiadamia IOD o udostępnieniu.
                  </Typography>
                  <Typography component="li">
                    Decyzję o udostępnieniu lub odmowie udostępnienia podejmuje
                    ADO.
                  </Typography>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 16
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="left"
                >
                  Odmowa udostępnienia danych osobowych następuje wówczas, gdy
                  spowodowałoby to istotne naruszenia dóbr osobistych osób,
                  których dane dotyczą lub innych osób oraz jeżeli dane osobowe
                  nie mają istotnego związku ze wskazanymi we wniosku motywami
                  działania wnioskodawcy.
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Powierzenie przetwarzania danych osobowych
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 17
                </Typography>
                <ol>
                  <Typography component="li">
                    Powierzenie przetwarzania danych osobowych odbywa się na
                    podstawie umowy zawartej na piśmie pomiędzy ADO, a podmiotem
                    przetwarzającym, któremu zleca się czynności związane z
                    przetwarzaniem danych osobowych.
                  </Typography>
                  <Typography component="li">
                    Właściciel zbiorów danych osobowych informuje IOD o zamiarze
                    powierzenia danych osobowych do przetwarzania innemu
                    podmiotowi i przedkłada projekt umowy powierzenia danych
                    osobowych.
                  </Typography>
                  <Typography component="li">
                    W projekcie umowy należy wskazać dokładny zakres czynności
                    związanych z przetwarzaniem powierzonych danych osobowych,
                    zakres danych oraz wymagania dotyczące ochrony danych.
                  </Typography>
                  <Typography component="li">
                    Projekt umowy parafują:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      właściciel zbioru danych osobowych,
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      IOD,
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      IBTI – jeżeli zlecenie czynności dotyczyć będzie
                      przetwarzania danych w systemie informatycznym,
                    </Typography>
                    <Typography point-attr="4)" component="li">
                      radca prawny,
                    </Typography>
                    <Typography point-attr="5)" component="li">
                      Sekretarz Województwa.
                    </Typography>
                  </ol>
                  <Typography component="li">
                    Zaparafowany projekt umowy jest przedkładany przez
                    Właściciela zbioru danych osobowych do akceptacji i podpisu
                    ADO.
                  </Typography>
                  <Typography component="li">
                    Podpisane umowy powierzenia przetwarzania danych osobowych
                    zbierają i przechowują Właściciele zbiorów danych osobowych.
                  </Typography>
                  <Typography component="li">
                    Każda podpisana umowa powierzenia podlega wpisaniu do
                    rejestru umów powierzenia przetwarzania danych osobowych
                    prowadzonego przez IOD. Wzór rejestru stanowi załącznik nr 8
                    do Polityki Bezpieczeństwa Przetwarzania Danych Osobowych.
                  </Typography>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 18
                </Typography>
                <ol>
                  <Typography component="li">
                    Podmiot przetwarzający dane osobowe jest zobowiązany do
                    zastosowania środków organizacyjnych i technicznych
                    określonych w przepisach o ochronie danych osobowych.
                  </Typography>
                  <Typography component="li">
                    Podmiot, o którym mowa w ust. 1, jest zobowiązany
                    przetwarzać dane osobowe wyłącznie w zakresie określonym
                    w umowie.
                  </Typography>
                  <Typography component="li">
                    Podmiot przetwarzający dane osobowe ponosi odpowiedzialność
                    za ochronę przetwarzanych danych osobowych.
                  </Typography>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                ></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Prawa i obowiązki IOD
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 19
                </Typography>
                <ol>
                  <Typography component="li">
                    W celu realizacji powierzonych zadań IOD w Urzędzie ma
                    prawo:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      weryfikować prawidłowość zabezpieczenia systemów
                      informatycznych oraz pomieszczeń, w których przetwarzane
                      są dane osobowe w poszczególnych komórkach organizacyjnych
                      Urzędu;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      instruować kierowników komórek organizacyjnych Urzędu w
                      zakresie bezpieczeństwa danych osobowych;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      informować ADO o przypadkach naruszenia bezpieczeństwa
                      danych osobowych;
                    </Typography>
                    <Typography point-attr="4)" component="li">
                      żądać od wszystkich pracowników Urzędu wyjaśnień
                      w sytuacjach naruszenia bezpieczeństwa danych osobowych.
                    </Typography>
                  </ol>
                  <Typography component="li">
                    2. Do zadań IOD należy:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      informowanie administratora, podmiotu przetwarzającego
                      oraz pracowników, którzy przetwarzają dane osobowe, o
                      obowiązkach spoczywających na nich na mocy RODO oraz
                      innych przepisów Unii lub państw członkowskich o ochronie
                      danych i doradzanie im w tej sprawie;
                    </Typography>
                    <Typography point-attr="1)" component="li">
                      monitorowanie przestrzegania RODO, innych przepisów Unii
                      lub państw członkowskich o ochronie danych oraz polityk
                      administratora lub podmiotu przetwarzającego w dziedzinie
                      ochrony danych osobowych, w tym podział obowiązków,
                      działania zwiększające świadomość, szkolenia pracowników
                      uczestniczących w operacjach przetwarzania oraz powiązane
                      z tym audyty;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      udzielanie na żądanie zaleceń co do oceny skutków dla
                      ochrony danych oraz monitorowanie jej wykonania zgodnie z
                      art. 35 RODO;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      współpraca z Urzędem Ochrony Danych Osobowych;
                    </Typography>
                    <Typography point-attr="4)" component="li">
                      pełnienie funkcji punktu kontaktowego dla organu
                      nadzorczego w kwestiach związanych z przetwarzaniem, w tym
                      z uprzednimi konsultacjami, o których mowa w art. 36 RODO,
                      oraz w stosownych przypadkach prowadzenie konsultacji
                      we wszelkich innych sprawach;
                    </Typography>
                    <Typography point-attr="5)" component="li">
                      nadzorowanie opracowania i aktualizowania dokumentacji
                      opisującej sposób przetwarzania danych oraz środki
                      techniczne i organizacyjne zapewniające ochronę
                      przetwarzanych danych osobowych odpowiednią do zagrożeń
                      oraz kategorii danych objętych ochroną, a także
                      przestrzegania zasad w niej określonych;
                    </Typography>
                    <Typography point-attr="6)" component="li">
                      zapewnianie zapoznania osób upoważnionych do przetwarzania
                      danych osobowych z przepisami o ochronie danych osobowych;
                    </Typography>
                    <Typography point-attr="7)" component="li">
                      prowadzenie ewidencji osób upoważnionych do przetwarzania
                      danych osobowych;
                    </Typography>
                    <Typography point-attr="8)" component="li">
                      prowadzenie rejestru czynności przetwarzania danych,
                      rejestru kategorii czynności przetwarzania danych i wykazu
                      zbiorów danych przetwarzanych przez Administratora;
                    </Typography>
                    <Typography point-attr="9)" component="li">
                      prowadzenie rejestru umów powierzenia przetwarzania danych
                      osobowych;
                    </Typography>
                    <Typography point-attr="10)" component="li">
                      wydawanie upoważnień do przetwarzania danych osobowych
                      oraz ich ewidencjonowanie;
                    </Typography>
                    <Typography point-attr="11)" component="li">
                      zatwierdzanie, modyfikowanie i akceptacja przed
                      przedłożeniem do podpisu ADO proponowanych zmian zasad i
                      procedur bezpieczeństwa przygotowywanych w Urzędzie
                      Marszałkowskim Województwa Podlaskiego w Białymstoku;
                    </Typography>
                  </ol>
                  <Typography component="li">
                    Podczas nieobecności IOD jego funkcję pełni ZIOD.
                  </Typography>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                ></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Obowiązki ASI
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 20
                </Typography>
                <ol>
                  <Typography component="li">
                    Administratorzy Systemów Informatycznych odpowiadają za
                    bezpieczeństwo danych osobowych przetwarzanych w systemach
                    informatycznych Urzędu.
                  </Typography>
                  <Typography component="li">
                    Do obowiązków ASI w zakresie ochrony danych osobowych należy
                    w szczególności:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      zapewnienie bezawaryjnego zasilania komputerów oraz innych
                      urządzeń mających wpływ na bezpieczeństwo przetwarzania
                      danych osobowych w Urzędzie;
                    </Typography>
                    <Typography point-attr="1)" component="li">
                      nadzór nad naprawami, konserwacją i likwidacją wycofanych
                      urządzeń komputerowych, na których zapisane są dane
                      osobowe;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      nadzór nad przeglądami, konserwacją, uaktualnianiem
                      systemów służących do przetwarzania danych osobowych;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      podejmowanie natychmiastowych działań zabezpieczających
                      stan systemu informatycznego w Urzędzie w przypadku
                      otrzymania informacji o naruszeniu zabezpieczeń
                      informatycznych;
                    </Typography>
                    <Typography point-attr="4)" component="li">
                      bezzwłoczne informowanie IOD o naruszeniu bezpieczeństwa
                      ochrony danych osobowych;
                    </Typography>
                    <Typography point-attr="5)" component="li">
                      nadzór nad przesyłaniem danych osobowych drogą
                      teletransmisji;
                    </Typography>
                    <Typography point-attr="6)" component="li">
                      nadzór nad przestrzeganiem zasad bezpieczeństwa w
                      przypadku udostępniania danych osobowych innym podmiotom
                      drogą teletransmisji danych;
                    </Typography>
                    <Typography point-attr="7)" component="li">
                      przeciwdziałanie dostępowi osób niepowołanych do systemu
                      informatycznego, w którym przetwarzane są dane osobowe;
                    </Typography>
                    <Typography point-attr="8)" component="li">
                      podejmowanie działań w przypadku naruszeń w systemie
                      zabezpieczeń;
                    </Typography>
                    <Typography point-attr="9)" component="li">
                      nadzór nad funkcjonowaniem mechanizmów uwierzytelniania
                      użytkowników oraz kontroli dostępu do danych osobowych;
                    </Typography>
                    <Typography point-attr="10)" component="li">
                      podejmowanie działań w zakresie ustalania i kontroli
                      identyfikatorów dostępu do systemu informatycznego.
                    </Typography>
                  </ol>{" "}
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                ></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Postępowanie w przypadkach naruszenia bezpieczeństwa ochrony
                  danych osobowych
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 21
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="left"
                >
                  Przepisy niniejszego rozdziału stosuje się w przypadku
                  naruszenia lub uzasadnionych podejrzeń naruszenia ochrony
                  danych osobowych lub zabezpieczenia danych osobowych.
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 22
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="left"
                >
                  Zasady postępowania w przypadku naruszenia bezpieczeństwa
                  danych osobowych obowiązują wszystkie osoby biorące udział w
                  procesie przetwarzania danych osobowych.
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 23
                </Typography>
                <ol>
                  <Typography component="li">
                    Naruszeniem lub uzasadnionym podejrzeniem naruszenia ochrony
                    danych osobowych jest każdy stwierdzony fakt:
                    nieuprawnionego ujawnienia danych osobowych, udostępnienia
                    lub umożliwienia dostępu do nich osobom nieupoważnionym,
                    zabrania danych przez osobę nieupoważnioną, uszkodzenia
                    jakiegokolwiek elementu systemu informatycznego,
                    a w szczególności:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      nieautoryzowany dostęp do danych;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      nieautoryzowane modyfikacje lub zniszczenie danych;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      udostępnienie danych nieautoryzowanym podmiotom;
                    </Typography>
                    <Typography point-attr="4)" component="li">
                      nielegalne ujawnienie danych;
                    </Typography>
                    <Typography point-attr="5)" component="li">
                      pozyskiwanie danych z nielegalnych źródeł.
                    </Typography>
                  </ol>{" "}
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 24
                </Typography>
                <ol>
                  <Typography component="li">
                    W przypadku stwierdzenia naruszenia lub uzasadnionych
                    podejrzeń naruszenia ochrony danych osobowych, każdy
                    pracownik zatrudniony przy przetwarzaniu danych osobowych
                    jest zobowiązany przerwać przetwarzanie danych osobowych
                    i niezwłocznie powiadomić o tym fakcie bezpośredniego
                    przełożonego oraz IOD, a następnie postępować stosownie do
                    podjętej przez IOD decyzji.
                  </Typography>
                  <Typography component="li">
                    Zgłoszenie naruszenia lub uzasadnionych podejrzeń naruszenia
                    ochrony danych osobowych powinno zawierać:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      opisanie działania wskazującego na naruszenie ochrony
                      danych osobowych;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      określenie sytuacji i czasu, w jakim stwierdzono
                      naruszenie ochrony danych osobowych;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      wskazanie istotnych informacji mogących wskazywać na
                      przyczynę naruszenia;
                    </Typography>
                    <Typography point-attr="4)" component="li">
                      określenie znanych danej osobie sposobów zabezpieczenia
                      systemu oraz wszelkich kroków podjętych po ujawnieniu
                      zdarzenia.
                    </Typography>
                  </ol>{" "}
                </ol>{" "}
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 25
                </Typography>
                <ol>
                  <Typography component="li">
                    IOD niezwłocznie po powzięciu wiadomości o naruszeniu lub
                    uzasadnionym podejrzeniu naruszenia ochrony danych osobowych
                    podejmuje działania mające na celu:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      minimalizację negatywnych skutków zdarzenia;
                    </Typography>
                    <Typography point-attr="1)" component="li">
                      wyjaśnienie okoliczności zdarzenia;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      zabezpieczenie dowodów zdarzenia,
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      umożliwienie dalszego bezpiecznego przetwarzania danych.
                    </Typography>
                  </ol>{" "}
                  <Typography component="li">
                    Dla realizacji celów określonych w ust. 1 IOD ma prawo do
                    podejmowania wszelkich działań dopuszczonych przez prawo, w
                    szczególności:
                  </Typography>
                  <ol className={classes.secondol}>
                    {" "}
                    <Typography point-attr="1)" component="li">
                      żądania wyjaśnień od pracowników;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      korzystania z pomocy konsultantów;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      nakazania przerwania pracy, zwłaszcza w zakresie
                      przetwarzania danych osobowych.
                    </Typography>
                  </ol>{" "}
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 26
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="left"
                >
                  Odmowa udzielenia wyjaśnień lub współpracy z IOD traktowana
                  będzie jako naruszenie obowiązków pracowniczych.
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 27
                </Typography>
                <ol>
                  <Typography component="li">
                    W przypadku naruszenia ochrony danych osobowych,
                    Administrator bez zbędnej zwłoki – w miarę możliwości, nie
                    później niż w terminie 72 godzin po stwierdzeniu naruszenia
                    – zgłasza je Prezesowi Urzędu Ochrony Danych Osobowych,
                    chyba że jest mało prawdopodobne, by naruszenie to
                    skutkowało ryzykiem naruszenia praw lub wolności osób
                    fizycznych.
                  </Typography>
                  <Typography component="li">
                    IOD prowadzi rejestr naruszeń ochrony danych osobowych, w
                    którym dokumentuje wszelkie naruszenia ochrony danych
                    osobowych, w tym okoliczności naruszenia ochrony danych
                    osobowych, jego skutki oraz podjęte działania zaradcze.
                  </Typography>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                ></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="left"
                >
                  Odpowiedzialność za naruszenie przepisów o ochronie danych
                  osobowych
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 28
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="left"
                >
                  Brak realizacji procedur określonych w Polityce Bezpieczeństwa
                  Przetwarzania Danych Osobowych i Polityce Zarządzania Systemem
                  Informatycznym jest naruszeniem obowiązków pracowniczych i
                  skutkuje odpowiedzialnością określoną w odpowiednich
                  przepisach prawa.
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                ></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Bezpieczeństwo
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 29
                </Typography>
                <ol>
                  <Typography component="li">
                    Stopień bezpieczeństwa stosowany w UMWP odpowiada ryzyku
                    naruszenia praw i wolności osób fizycznych wskutek
                    przetwarzania danych osobowych przez UMWP.
                  </Typography>
                  <Typography component="li">
                    Administrator przeprowadza i dokumentuje analizy
                    adekwatności środków bezpieczeństwa danych osobowych. W tym
                    celu:
                  </Typography>
                  <ol className={classes.secondol}>
                    <Typography point-attr="1)" component="li">
                      zapewnia się odpowiedni stan wiedzy o bezpieczeństwie
                      informacji, cyberbezpieczeństwie i ciągłości działania −
                      wewnętrznie lub ze wsparciem podmiotów wyspecjalizowanych;
                    </Typography>
                    <Typography point-attr="2)" component="li">
                      przeprowadzane są analizy ryzyka naruszenia praw lub
                      wolności osób fizycznych dla czynności przetwarzania
                      danych lub ich kategorii. Analizie podlegają możliwe
                      sytuacje i scenariusze naruszenia ochrony danych osobowych
                      uwzględniając charakter, zakres, kontekst i cele
                      przetwarzania, ryzyko naruszenia praw lub wolności osób
                      fizycznych o różnym prawdopodobieństwie wystąpienia i
                      wadze zagrożenia;
                    </Typography>
                    <Typography point-attr="3)" component="li">
                      na podstawie przeprowadzonych analiz ustalane są możliwe
                      do zastosowania organizacyjne i techniczne środki
                      bezpieczeństwa z uwzględnieniem kosztów ich wdrażania. W
                      tym celu stosowane są takie środki jak: pseudonimizacja,
                      szyfrowanie danych osobowych oraz inne zapewniające
                      ciągłość działania i zapobiegania skutkom katastrof, czyli
                      zapewniające zdolność do szybkiego przywrócenia
                      dostępności danych osobowych i dostępu do nich w razie
                      incydentu fizycznego lub technicznego.
                    </Typography>
                  </ol>
                  <Typography component="li">
                    W przypadku gdy istotność ryzyka, zgodnie z przeprowadzoną
                    analizą ryzyka naruszenia praw i wolności osób, jest poważna
                    dokonuje się oceny skutków planowanych operacji
                    przetwarzania dla ochrony danych osobowych.
                  </Typography>
                  <Typography component="li">
                    Do oceny skutków stosuje się metodykę przyjętą w UMWP w
                    zarządzeniu Marszałka regulującym zarządzanie ryzykiem w
                    UMWP.
                  </Typography>
                </ol>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                ></Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  Rozdział III Postanowienia końcowe
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="center"
                >
                  § 30
                </Typography>
                <Typography
                  component="p"
                  display="block"
                  paragraph
                  align="left"
                >
                  W sprawach nieuregulowanych niniejszym dokumentem znajdują
                  zastosowanie przepisy Ustawy oraz inne przepisy szczególne.
                </Typography>
              </Box>
            </Paper>
            <Box>
              <Paper>
                <Box mt={1} p={1}>
                  <Typography
                    component="p"
                    display="block"
                    variant="subtitle2"
                    paragraph
                  >
                    Ponadto aplikacja Portal KM {getSystemLabel('programShortcut', globalData.systemInfo)}, którego właścicielem jest
                    Urząd Marszałkowski Województwa Podlaskiego używa plików
                    cookies, aby ułatwić użytkownikom korzystanie z serwisu oraz
                    do celów technicznych i statystycznych. Jeśli nie blokujesz
                    tych plików, to zgadzasz się na ich użycie oraz zapisanie w
                    pamięci Twojego komputera lub innego urządzenia. Pamiętaj,
                    że możesz zmienić ustawienia przeglądarki tak, aby
                    zablokować zapisywanie plików cookies, jednakże uniemożliwia
                    to zalogowanie się do systemu.
                  </Typography>

                  <Typography component="p" display="block">
                    Czy akceptujesz warunki Polityki Bezpieczeństwa Danych
                    Osobowych w Urzędzie Marszałkowskim Województwa Podlaskiego
                    w Białymstoku?
                  </Typography>
                </Box>
              </Paper>
            </Box>
            <Box my={2}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Paper className={classes.paper}>
                    <Button
                      color="primary"
                      fullWidth
                      size="large"
                      onClick={noAcceptPolicy}
                    >
                      Nie
                    </Button>
                  </Paper>
                </Grid>
                <Grid item xs={6}>
                  <Paper className={classes.paper}>
                    <Button
                      color="primary"
                      fullWidth
                      size="large"
                      variant="contained"
                      onClick={acceptPolicy}
                    >
                      Tak
                    </Button>
                  </Paper>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Container>
      <Box display="flex" alignItems="flex-end" flexGrow={1} p={1}>
        <Box display="flex" flexDirection="column">
          <img
            className={classes.img}
            alt="Logo UE stopka"
            src="/static/images/logo_ue_main.jpg"
          />
          <Typography
            variant="caption"
            gutterBottom
            color="textSecondary"
            align="center"
            component="p"
          >
            Aplikacja współfinansowana przez Unię Europejską ze środków
            Europejskiego Funduszu Społecznego w ramach Regionalnego Programu
            Operacyjnego Województwa Podlaskiego na lata 2014-2020
          </Typography>
          <Typography
            color="textPrimary"
            variant="subtitle2"
            align="center"
            component="p"
          >
            2021 © Urząd Marszałkowski Województwa Podlaskiego
          </Typography>
        </Box>
      </Box>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  setAuthorized: (isAuthorized) =>
    dispatch(actions.setAuthorized(isAuthorized)),
  setCurrentUserData: (currentUserData) =>
    dispatch(actions.setCurrentUser(currentUserData)),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
});

export default connect(mapStateToProps, mapDispatchToProps)(PolicyView);
